import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import InventorySourceGroupPropType from './prop-types/inventory-source-group';
import isMatch from 'lodash.ismatch';
import { inventoryWarehouseTypes } from './constants';
import InventorySourceName from './inventory-source-name';
import messages from '../messages';

const InventorySourceDropdownToggler = ({ inventorySourceGroups, selectedInventorySource }) => {
  const intl = useIntl();
  const selectedInventorySourceGroup = inventorySourceGroups.find((inventorySourceGroup) => {
    return inventorySourceGroup.warehouses?.find((inventorySource) => isMatch(inventorySource, selectedInventorySource));
  });

  return (
    <InventorySourceName inventorySource={selectedInventorySource}>
      {(inventorySourceName) => {
        if (selectedInventorySource.warehouseType === inventoryWarehouseTypes.aggregate) {
          return intl.formatMessage(messages.externalWarehouseDropdownLabel, {
            externalInventoryProviderName: selectedInventorySourceGroup.warehouseGroupName,
            externalInventorySourceName: inventorySourceName,
          });
        }
        return inventorySourceName;
      }}
    </InventorySourceName>
  );
};

InventorySourceDropdownToggler.propTypes = {
  inventorySourceGroups: PropTypes.arrayOf(InventorySourceGroupPropType).isRequired,
  selectedInventorySource: PropTypes.object.isRequired,
};

export default InventorySourceDropdownToggler;
